import { useEffect, useState } from 'react';

const useZoomDetection = () => {
  const [userZooming, setUserZooming] = useState(false);

  const isUserZooming = () => {
    const zoomThreshold = 50;

    return !(
      window.outerWidth - zoomThreshold <= window.innerWidth &&
      window.outerWidth + zoomThreshold >= window.innerWidth
    );
  };

  useEffect(() => {
    if (typeof ResizeObserver !== 'function') return;
    const observer = new ResizeObserver(() => {
      const zoom = isUserZooming();
      if (zoom !== userZooming) {
        setUserZooming(zoom);
      }
    });
    observer.observe(document.documentElement);
    return () => {
      observer.disconnect();
    };
  }, [userZooming]);

  return userZooming;
};

export default useZoomDetection;
